import { IMAGES_RENDER } from "../constants/ActionTypes"

const initState = {
    IMAGES: "https://sslstage1.sephorastatic.cn/soa/public/images/public_images45.gif",
    PLACEHOLDER: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAAtJREFUCB1jYAACAAAFAAGNu5vzAAAAAElFTkSuQmCC"
}

export default function (state = initState, action = {}) {
    switch (action.type) {
        default:
            return state; break;
    }
}


// WEBPACK FOOTER //
// ./common/reducers/imagesRender.js